module.exports = {
      id: "share-dark-greybg-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#share-dark-greybg",
      toString: function () {
        return this.url;
      }
    }